/**
 * Centralised business information.
 */
const CONTACT_EMAIL = "anish.sudarsan@gmail.com";

export const BUSINESS = {
  name: "Pawventure Essentials",
  legalName: "Pawventure Essentials",
  domain: "pawventureessentials.com",
  url: "https://pawventureessentials.com",
  email: {
    support: CONTACT_EMAIL,
    returns: CONTACT_EMAIL,
    privacy: CONTACT_EMAIL,
    legal: CONTACT_EMAIL,
  },
  phone: "+1 (470) 469-1719",
  address: {
    line1: "6910 Ellorie Drive",
    line2: "",
    city: "Dawsonville",
    state: "GA",
    postal: "30534",
    country: "United States",
  },
  jurisdiction: "Georgia, United States",
  establishedYear: 2025,
};

export const addressOneLine = ({ line1, line2, city, state, postal, country } = BUSINESS.address) =>
  [line1, line2, [city, state, postal].filter(Boolean).join(", "), country].filter(Boolean).join(" · ");
